export default __webpack_public_path__ + "check-box-empty.png";